/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Col, Divider, Row, Skeleton, Tabs } from 'antd';
import Icon, { CheckCircleOutlined } from '@ant-design/icons';
import { Text } from 'shared/components';
import { useQuery } from 'react-query';

import { axiosErp } from 'shared/config/axios';
import { getStoredAuthToken } from 'shared/utils/authToken';
import formatCurrency from 'shared/utils/formatCurrency';
import { color } from 'shared/utils/styles';
import IconFileInvoiceDollar from 'shared/assets/icons/file-invoice-dollar.svg';
import IconHourGlassHalf from 'shared/assets/icons/hourglass-half.svg';
import { formatDate } from 'shared/utils/dateTime';
import { CardContainer, StyledCardIcon } from './Styles';
import TagStatus from './TagStatus';
import CostingOtherDocument from './CostingOtherDocument';
import HaierCostingTable from './HaierCostingTable';
import HaierOrderTable from './HaierOrderTable';

const { TabPane } = Tabs;

interface CostingDetailProps {
  costingId: string;
}

const CostingDetail: React.FC<CostingDetailProps> = (props) => {
  const { costingId } = props;
  const token = getStoredAuthToken();

  const { data, isLoading, isError } = useQuery(
    ['costing-job-detail', costingId],
    async () => {
      const costingData = await axiosErp(token).get(`/costing-job/${costingId}`);
      return costingData.data;
    },
    {
      enabled: Boolean(costingId),
      onError: (err) => {
        console.error('ERROR TO LOAD COSTING DETAIL: ', err);
      },
    },
  );

  let content = <Skeleton />;
  if (data && !isLoading && !isError) {
    const {
      costingDate,
      costingNumber,
      costingStatus,
      customer,
      employee,
      invoice,
      payment,
      profit,
      remark,
      totalAfterDiscount,
      vendor,
      jobNumber,
      tripNo,
    } = data;

    content = (
      <>
        <CardContainer>
          <StyledCardIcon
            title="ต้นทุนก่อนภาษี / Cost Before VAT"
            text={
              <Text customType="normal">{`${formatCurrency(
                totalAfterDiscount ? Number(totalAfterDiscount.cost) : 0,
              )} บาท`}</Text>
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            icon={<Icon component={IconFileInvoiceDollar} />}
          />

          <StyledCardIcon
            title="รายได้ก่อนภาษี / Revenue Before VAT"
            text={
              <Text customType="normal">{`${formatCurrency(
                totalAfterDiscount ? Number(totalAfterDiscount.sale) : 0,
              )} บาท`}</Text>
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            icon={<Icon component={IconFileInvoiceDollar} />}
          />

          <StyledCardIcon
            title="กำไรขั้นต้น / Gross Profit"
            text={
              <Text customType={Number(profit) < 0 ? 'danger' : 'success'}>{`${formatCurrency(
                profit ? Number(profit) : 0,
              )} บาท`}</Text>
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            icon={<Icon component={IconFileInvoiceDollar} />}
          />

          <StyledCardIcon
            title="เหลือเวลาในการดำเนินงาน"
            text="-"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            icon={<Icon component={IconHourGlassHalf} />}
          />
        </CardContainer>

        <Divider style={{ margin: '10px 0' }} />

        <Row gutter={[32, 16]}>
          <Col span={9} style={{ borderRight: `1px dashed ${color.grey}` }}>
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={8}>
                    ชื่อลูกค้า <Text customType="grey">(ลูกหนี้)</Text>:
                  </Col>
                  <Col span={16}>
                    <Text strong>{customer.customerName}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>
                    ผู้รับเงิน <Text customType="grey">(เจ้าหนี้)</Text>:
                  </Col>
                  <Col span={16}>
                    <Text strong>{vendor.vendorName}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>ช่องทางการชำระ:</Col>
                  <Col span={16}>
                    <Text strong>{data.channelType === 1 ? 'โอนเงิน' : 'เงินสด'}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>หมายเหตุ:</Col>
                  <Col span={16}>
                    <Text strong>{remark || '-'}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={8} style={{ borderRight: `1px dashed ${color.grey}` }}>
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={8}>อ้างอิงรหัสทริป:</Col>
                  <Col span={16}>
                    <Text strong>{tripNo}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>อ้างอิงรหัสงานขนส่ง:</Col>
                  <Col span={16}>
                    <Text strong>{jobNumber}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>อ้างอิงใบสั่งจ่าย:</Col>
                  <Col span={16}>
                    <Text strong>
                      {payment.length > 0
                        ? `${payment.map((item) => item.payment_number).join(', ')}`
                        : '-ไม่มี-'}
                    </Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>อ้างอิงใบแจ้งหนี้:</Col>
                  <Col span={16}>
                    <Text strong>
                      {invoice.length > 0
                        ? `${invoice.map((item) => item.invoice_number).join(', ')}`
                        : '-ไม่มี-'}
                    </Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={7}>
            <Row>
              <Col span={24}>
                <Row>
                  <Col span={8}>สถานะ:</Col>
                  <Col span={16}>
                    <TagStatus status={costingStatus} />
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>รหัสต้นทุน/ขาย:</Col>
                  <Col span={16}>
                    <Text strong>{costingNumber || '-ไม่มี-'}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>วันที่ส่งรายการ:</Col>
                  <Col span={16}>
                    <Text strong>{formatDate(costingDate)}</Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={8}>ผู้ส่งราคา:</Col>
                  <Col span={16}>
                    <Text strong>{employee ? employee.employeeName : '-ไม่มี-'}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>

        <Divider style={{ margin: 0, marginTop: -5 }} />

        <Tabs defaultActiveKey="1" animated={false} destroyInactiveTabPane>
          <TabPane
            tab={
              <span>
                รายการจ่าย{' '}
                <CheckCircleOutlined style={{ color: `${color.success}`, marginLeft: 5 }} />
              </span>
            }
            key="1"
          >
            <HaierCostingTable costingData={data} />
          </TabPane>
          <TabPane
            tab={
              <span>
                แจกแจงรายการ{' '}
                <CheckCircleOutlined style={{ color: `${color.success}`, marginLeft: 5 }} />
              </span>
            }
            key="2"
          >
            <HaierOrderTable costingData={data} />
          </TabPane>
          <TabPane
            tab={
              <span>
                ไฟล์ที่เกี่ยวข้อง{' '}
                <CheckCircleOutlined style={{ color: `${color.success}`, marginLeft: 5 }} />
              </span>
            }
            key="3"
          >
            <CostingOtherDocument costingId={costingId} />
          </TabPane>
        </Tabs>
      </>
    );
  }

  return content;
};

export default CostingDetail;
